<div class="chart-container">
  <div
    class="chart-infoBar"
    [class.hidden]="!_chartModel?.tooltipEnabled"
    #infoBar
  ></div>
  <div #chart style="width: 100%" (resize)="onResize()"></div>
</div>
